
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useCentralizedAuth } from '@/context/CentralizedAuthProvider';
import HeroSection from '@/components/home/HeroSection';
import PackageSelection from '@/components/home/PackageSelection';
import CTAButtons from '@/components/home/CTAButtons';
import StatsSection from '@/components/home/StatsSection';
import HowItWorksSection from '@/components/home/HowItWorksSection';
import TestimonialsSection from '@/components/home/TestimonialsSection';
import CredibilitySection from '@/components/home/CredibilitySection';
import ExpertGuidanceSection from '@/components/home/ExpertGuidanceSection';
import WhatsAppBot from '@/components/home/WhatsAppBot';

const Index = () => {
  const { isAuthenticated } = useCentralizedAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger animations after component mounts
    setVisible(true);
  }, []);

  const handlePackageSelect = (packageType: 'silver' | 'gold') => {
    if (!isAuthenticated) {
      // Redirect to login page with return URL
      navigate(`/login?redirect=payment&package=${packageType}`);
      return;
    }
    
    // Navigate to payment page
    navigate(`/payment?package=${packageType}`);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <HeroSection />

        {/* Package Selection Section */}
        <PackageSelection 
          visible={visible} 
          onPackageSelect={handlePackageSelect} 
        />

        {/* CTA Buttons */}
        <CTAButtons />

        {/* Stats Section */}
        <StatsSection visible={visible} />

        {/* How It Works Section */}
        <HowItWorksSection visible={visible} />

        {/* Credibility Section */}
        <CredibilitySection visible={visible} />

        {/* Testimonials Section */}
        <TestimonialsSection visible={visible} />
        
        {/* Expert Guidance Section */}
        <ExpertGuidanceSection visible={visible} />

        {/* Review Widget Section */}
        <section className="py-8 px-4 sm:px-6 md:px-8">
          <div className="max-w-7xl mx-auto">
            <iframe 
              src="https://reviewmanagementtool.com/embed/widget/6469b98b-995f-46f1-bea5-d59a482dbd67" 
              width="100%" 
              height="400" 
              frameBorder="0"
              title="Review Widget"
            />
          </div>
        </section>
      </main>

      <Footer />
      
      {/* WhatsApp Bot */}
      <WhatsAppBot />
    </div>
  );
};

export default Index;
